package com.tovtalk.ui.platform

import androidx.compose.runtime.Composable
import kotlinx.browser.window

@Composable
actual fun rememberAddContactToDevice(): (name: String, phone: String) -> Unit {
    return { name, phone ->
        val text = "$name: $phone"
        try {
            @Suppress("UNUSED_VARIABLE")
            val promise = window.asDynamic().navigator.clipboard?.writeText(text)
            // Optionally show a toast that text was copied
        } catch (_: Throwable) { }
    }
}
